import Events from "@/utils/Events";
import Log from "@/utils/Log";
import {StatsigClient} from "@statsig/js-client";

/**
 * Ponte entre o sistema de eventos do checkout e o Statsig.
 *
 * Só existe pra alimentar as métricas dos experimentos. Fica de propósito
 * fora de qualquer código de variante: os listeners são registrados uma vez
 * no load (ListenerEvents) e disparam igual no controle e no teste, porque o
 * Events não sabe em que grupo o usuário caiu. É isso que permite comparar
 * os dois grupos.
 *
 * Métricas do experimento "offer_details_highlight":
 *  - denominador: assine_detalhes_visualizado (com metadata.variant)
 *  - primária:    assine_pedido_realizado  (viu a tela de Sucesso = gerou pedido)
 *  - secundária:  assine_login_sucesso
 *  - secundária:  assine_cadastro_sucesso
 */

export const STATSIG_DETALHES_VISUALIZADO = 'assine_detalhes_visualizado'
export const STATSIG_PEDIDO_REALIZADO = 'assine_pedido_realizado'
export const STATSIG_LOGIN_SUCESSO = 'assine_login_sucesso'
export const STATSIG_CADASTRO_SUCESSO = 'assine_cadastro_sucesso'

/** metadata do Statsig só aceita string */
const asMetadata = (data: Record<string, any>): Record<string, string> => {
    const metadata: Record<string, string> = {}

    Object.keys(data).forEach(key => {
        const value = data[key]
        if (value !== undefined && value !== null && typeof value !== 'object') {
            metadata[key] = String(value)
        }
    })

    return metadata
}

export const logStatsigEvent = (eventName: string, data: Record<string, any> = {}): void => {
    try {
        StatsigClient.instance().logEvent(eventName, undefined, asMetadata(data))
        Log.log('statsig_event:', eventName, data)
    } catch (error) {
        // métrica de experimento nunca pode derrubar o checkout
        Log.log('statsig_event_error:', eventName, error)
    }
}

const StatsigEvents = (events: Events): void => {
    // PRIMÁRIA — tela de Sucesso vista, ou seja, pedido gerado
    events.addEventListener("pagamento_sucesso_visualizado", (data) => {
        logStatsigEvent(STATSIG_PEDIDO_REALIZADO, {
            offer_type: data?.offer_type ?? ''
        })
    })

    // SECUNDÁRIA — login concluído (e-mail/senha ou Google)
    events.addEventListener([
        "identificacao_login_sucesso",
        "identificacao_login_google_sucesso"
    ], (data, key) => {
        logStatsigEvent(STATSIG_LOGIN_SUCESSO, {
            offer_type: data?.offer_type ?? '',
            origem: key
        })
    })

    // SECUNDÁRIA — cadastro novo concluído
    events.addEventListener("identificacao_cadastro_sucesso", (data) => {
        logStatsigEvent(STATSIG_CADASTRO_SUCESSO, {
            offer_type: data?.offer_type ?? ''
        })
    })
}

export default StatsigEvents
